import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Search from '@/icons/Search';
import Close from '@/icons/Close';

interface FamilyMembersSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

const FamilyMembersSearch: React.FC<FamilyMembersSearchProps> = ({
  value,
  onChange,
  placeholder,
  debounceMs = 250
}) => {
  const { t } = useTranslation('forms');
  const [inputValue, setInputValue] = useState<string>(value);
  const resolvedPlaceholder = placeholder ?? t('person.searchByNameOrBirthplace');

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(inputValue);
    }, debounceMs);

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, onChange, debounceMs]);

  const handleClear = () => {
    setInputValue('');
    onChange('');
  };

  return (
    <div className="list-search-field">
      <span className="list-search-field__icon">
        <Search width={16} height={16} />
      </span>
      <input
        type="text"
        className="list-search-field__input"
        placeholder={resolvedPlaceholder}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        aria-label={t('person.searchFamilyMembersAria')}
      />
      {inputValue && (
        <button
          type="button"
          className="list-search-field__clear"
          onClick={handleClear}
          aria-label={t('actions.clearSearch')}
        >
          <Close width={14} height={14} />
        </button>
      )}
    </div>
  );
};

export default FamilyMembersSearch;
